export default __webpack_public_path__ + "static/Tom.Dale_9185Flags_social-6199fa0a6dc65733d4472a4f290819c0.jpg";